/**
 * Do not edit directly, this file was auto-generated.
 */

export const SlLegacyBlue = "#009ff5";
export const Information100DarkUi = "#a46eff";
export const Information100LightUi = "#804ad9";
export const InformationLight10 = "#f3edfc";
export const InformationDark10 = "#413d4c";
export const InformationLight30 = "#d9c9f4";
export const InformationDark30 = "#574873";
export const InformationDarkTypography = "#c9abff";
export const Warning100DarkUi = "#ff8126";
export const WarningLight10 = "#ffede6";
export const WarningDark10 = "#4a3e36";
export const WarningLight20 = "#ffdbcc";
export const WarningDark20 = "#5e4635";
export const Pass100LightUi = "#009921";
export const Pass100DarkUi = "#00c12b";
export const WarningTypographyLightUi = "#d3440d";
export const PassTypographyLightUi = "#00801c";
export const Fail100LightUi = "#c4000c";
export const Fail100DarkUi = "#ff4663";
export const Black75 = "#818386";
export const Black15 = "#f1f1f2";
export const Black7 = "#f5f5f5";
export const White = "#ffffff";
export const Black88 = "#252526";
export const Black85 = "#363738";
export const Black80 = "#505153";
export const Black = "#000000";
export const Black95 = "#0e0f0f";
export const Black91 = "#161617";
export const ForestGreen = "#074023";
export const DigitalGreenLight = "#009b65";
export const DigitalGreenLight10 = "#e6f5f0";
export const DigitalGreenLight30 = "#b3e1d1";
export const Brand85 = "#26a97c";
export const Brand100 = "#009b65";
export const Fail85 = "#cf1a37";
export const NiSky = "#3cb4e7";
export const BannerFail100DarkUi = "#d63434";
export const Warning100LightUi = "#ff4b00";
export const Black91V10 = "#e8e8e8";
export const Black30 = "#d3d5d6";
export const Black82V100 = "#6e6f70";
export const Black77V100 = "#6f7073";
export const Black50 = "#aeb0b3";
export const DigitalGreenDark = "#008557";
export const DigitalGreenDark105 = "#00734b";
export const DigitalGreenDark110 = "#00613f";
export const PowerGreen = "#32eb96";
export const PowerGreen10 = "#364941";
export const PowerGreen30 = "#356d54";
export const PowerGreenDark50 = "#98f5ca";
export const Black22 = "#e6e6e6";
export const CmykNiPaleGreen = "#ccdcc8";
export const RgbNiPaleGreen = "#cddcc8";
export const RgbNiForestGreen = "#044123";
export const CmykNiNickel = "#aea19a";
export const CmykNiForestGreen = "#044123";
export const RgbNiGreen = "#03b585";
export const CmykNiGreen = "#03b585";
export const CmykNiHoneyDark3 = "#292011";
export const Black82 = "#434445";
export const IndigoDark1 = "#57539e";
export const IndigoDark2 = "#312e7f";
export const NiHoneyLight = "#ffe76b";
export const NiScarlet = "#ef463f";
export const NiFern = "#76bc43";
export const NiScarletDark3 = "#371615";
export const NiScarletDark1 = "#cd1722";
export const NiFernDark1 = "#499146";
export const NiSea = "#00aba5";
export const NiSeaLight = "#a5d8c8";
export const NiTulip = "#e54c8a";
export const NiTulip10 = "#fdeef4";
export const NiTulipDark10 = "#483a41";
export const NiTulip20 = "#fadbe8";
export const NiTulipDark20 = "#593b49";
export const NiIndigo = "#8e78b7";
export const NiPlumDark1 = "#8c459a";
export const NiIndigoDark2 = "#312e7f";
export const NiSeaDark2 = "#00685f";
export const NiSpec10 = "#e6f6fb";
export const NiSpecDark10 = "#304147";
export const NiSpec20 = "#ccecf6";
export const NiSpecDark20 = "#2b4c57";
export const NiSpec = "#00a1d4";
export const BrownLight10 = "#f1eeeb";
export const BrownDark10 = "#403e3d";
export const BrownLight20 = "#e2dcd7";
export const BrownDark20 = "#4a4440";
export const BrownLight = "#6f4e37";
export const BrownDark = "#9b7a60";
export const Title2Family = "Source Sans Pro";
export const Title2Weight = "400";
export const ControlLabel1Family = "Source Sans Pro";
export const ControlLabel1Weight = "600";
export const BodyFamily = "Source Sans Pro";
export const BodyWeight = "400";
export const Body2Family = "Source Sans Pro";
export const Body2Weight = "400";
export const Header0Family = "Noto Serif";
export const Header0Weight = "400";
export const SubHeaderFamily = "Source Sans Pro";
export const SubHeaderWeight = "400";
export const Header1Family = "Noto Serif";
export const Header1Weight = "400";
export const GroupLabel1Family = "Source Sans Pro";
export const GroupLabel1Weight = "600";
export const ButtonLabel1Family = "Source Sans Pro";
export const ButtonLabel1Weight = "600";
export const Title1Family = "Source Sans Pro";
export const Title1Weight = "400";
export const LinkColorUiFamily = "Source Sans Pro";
export const LinkColorUiWeight = "400";
export const LinkDarkUiFamily = "Source Sans Pro";
export const LinkDarkUiWeight = "400";
export const Headline2Family = "Noto Serif";
export const Headline2Weight = "400";
export const PlaceholderFamily = "Source Sans Pro";
export const PlaceholderWeight = "400";
export const TooltipCaptionFamily = "Source Sans Pro";
export const TooltipCaptionWeight = "400";
export const BodyEmphasizedFamily = "Source Sans Pro";
export const BodyEmphasizedWeight = "600";
export const BodyEmphasized2Family = "Source Sans Pro";
export const BodyEmphasized2Weight = "600";
export const Subtitle1Family = "Source Sans Pro";
export const Subtitle1Weight = "300";
export const Title3Family = "Source Sans Pro";
export const Title3Weight = "400";
export const Subtitle2Family = "Source Sans Pro";
export const Subtitle2Weight = "300";
export const LinkLightUiFamily = "Source Sans Pro";
export const LinkLightUiWeight = "400";
export const Headline1Family = "Noto Serif";
export const Headline1Weight = "400";
export const ControlLabel1ChineseMacFamily = "Noto Sans";
export const ControlLabel1ChineseMacWeight = "700";
export const ButtonLabel1ChineseMacFamily = "Noto Sans";
export const ButtonLabel1ChineseMacWeight = "400";
export const BodyChineseMacFamily = "Noto Sans";
export const BodyChineseMacWeight = "400";
export const ErrorColorUiFamily = "Source Sans Pro";
export const ErrorColorUiWeight = "400";
export const LinkVisitedLightUiFamily = "Source Sans Pro";
export const LinkVisitedLightUiWeight = "400";
export const ErrorLightUiFamily = "Source Sans Pro";
export const ErrorLightUiWeight = "400";
export const ErrorDarkUiFamily = "Source Sans Pro";
export const ErrorDarkUiWeight = "400";
export const LinkSelection100LightUiFamily = "Source Sans Pro";
export const LinkSelection100LightUiWeight = "400";
export const GridHeaderFamily = "Source Sans Pro";
export const GridHeaderWeight = "600";
export const GroupLabelExpanderFamily = "Source Sans Pro";
export const GroupLabelExpanderWeight = "600";
export const Title2Size = "22px";
export const ControlLabel1Size = "11px";
export const BodySize = "14px";
export const Body2Size = "16px";
export const Header0Size = "36px";
export const SubHeaderSize = "12px";
export const Header1Size = "24px";
export const GroupLabel1Size = "11px";
export const ButtonLabel1Size = "14px";
export const Title1Size = "19px";
export const LinkColorUiSize = "14px";
export const LinkDarkUiSize = "14px";
export const Headline2Size = "29.1px";
export const PlaceholderSize = "14px";
export const TooltipCaptionSize = "11px";
export const BodyEmphasizedSize = "14px";
export const BodyEmphasized2Size = "16px";
export const Subtitle1Size = "12.8px";
export const Title3Size = "25px";
export const Subtitle2Size = "16px";
export const LinkLightUiSize = "14px";
export const Headline1Size = "25px";
export const ControlLabel1ChineseMacSize = "11px";
export const ButtonLabel1ChineseMacSize = "11px";
export const BodyChineseMacSize = "13px";
export const ErrorColorUiSize = "11px";
export const LinkVisitedLightUiSize = "14px";
export const ErrorLightUiSize = "11px";
export const ErrorDarkUiSize = "11px";
export const LinkSelection100LightUiSize = "14px";
export const GridHeaderSize = "12.8px";
export const GroupLabelExpanderSize = "14px";
export const BodyLineHeight = "18px";
export const Body2LineHeight = "16px";
export const ControlLabel1LineHeight = "16px";
export const GroupLabel1LineHeight = "16px";
export const Headline2LineHeight = "40px";
export const Headline1LineHeight = "32px";
export const Title3LineHeight = "32px";
export const Title2LineHeight = "28px";
export const Title1LineHeight = "24px";
export const Subtitle2LineHeight = "20px";
export const Subtitle1LineHeight = "16px";
export const LinkLineHeight = "18px";
export const PlaceholderLineHeight = "18px";
export const BodyEmphasizedLineHeight = "18px";
export const BodyEmphasized2LineHeight = "16px";
export const ButtonLabel1LineHeight = "16px";
export const TooltipCaptionLineHeight = "14px";
export const SmallDelay = "0.075s"; // Short animation delay used for control state change animation
export const MediumDelay = "0.15s"; // Medium animation delay for control state change animation
export const LargeDelay = "0.25s"; // Long animation delay used for control state change animation
